export default function onboardingProcess() {
    const url = location.pathname;
    const onboardingWrapper = $('#OnboardingSectionWrapper')

    if(onboardingWrapper.length > 0){
        initialiseButtons();
    }

    function reloadOnboardingSection(filters = null){
        let urlToCall = url;
        if(filters !== null){
            urlToCall = url + filters;
        }

        $.ajax({
            type: "GET",
            url: urlToCall,
            success: function(response) {
                var html = $(response);
                var resource_data = html.find('#OnboardingSectionWrapper').children();
                if (resource_data.length > 0) {
                    $('#OnboardingSectionWrapper').html('');
                    $('#OnboardingSectionWrapper').append(resource_data);
                }
                initialiseButtons();
                history.pushState(null, null, url);
            },
            error: function() {
                console.log("There was an error");
                console.error();
            },
        });
    }

    function initialiseButtons(){
        $('.accordion-body-footer-button-item').on('click',function(){
            let clickedItem = $(this);

            let currentStep = clickedItem.attr('data-currentstep');
            let currentStepId = clickedItem.attr('data-currentstepid');
            let currentMember = clickedItem.attr('data-memberid');
            let isCompleted = clickedItem.attr('data-completed-step');

            let filter =  '?member='+currentMember+'&stepId='+currentStepId;
            if(isCompleted === 'false'){
                filter = filter + '&step='+currentStep;
            } else {
                filter = filter + '&step='+currentStep+'&complete=true';
            }
            reloadOnboardingSection(filter);
        });
    }

}
